export const MapsApikey = 'AIzaSyDG-_trih7faQQigzdCiHWIG1dT0Fqfn-o';
export const AgoraAppID = 'c77bb1ec6ae9475f93edcad147f39a1d';
